module.exports = __webpack_public_path__ + "static/media/ticket.520062d5.png";